module.exports = __webpack_public_path__ + "assets/blacklist_user.7b0d83d0.svg";